import { computed, observable, action, makeObservable } from 'mobx';

import { ApiBookingPane, ApiBookingSearch } from '@ibe/api';
import ApiService from '../Api/ApiService';
import LoggerFactory from '../../Util/Logger/LoggerFactory';

class ManageBookingService {
  private logger = LoggerFactory.get('ManageBookingService');

  private api: ApiService | null = null;

  private isBusyValue = true;

  private hasErrorValue = false;

  constructor() {
    makeObservable<ManageBookingService, 'isBusyValue' | 'hasErrorValue'>(this, {
      isBusyValue: observable,
      hasErrorValue: observable,
      isBusy: computed,
      hasError: computed,
      searchBookings: action
    });
  }

  setApi(api: ApiService): void {
    this.api = api;
  }

  get isBusy(): boolean {
    return this.isBusyValue;
  }

  get hasError(): boolean {
    return this.hasErrorValue;
  }

  async searchBookings(apiBookingSearch?: ApiBookingSearch): Promise<ApiBookingPane[] | undefined> {
    if (!this.api) {
      throw new Error('No API instance.');
    }
    this.isBusyValue = true;
    try {
      const result = this.api.searchBookings(apiBookingSearch);
      this.hasErrorValue = false;
      this.isBusyValue = false;
      return result;
    } catch (e) {
      this.logger.error(e);
      this.hasErrorValue = true;
    }
    return undefined;
  }
}
export default ManageBookingService;
